const mockedSeoTags = [{
  count: 2500, key: 'car', show: true, tag: 'car',
}, {
  count: 1000, key: 'animals', show: true, tag: 'animals',
}, {
  count: 90, key: 'fish', show: true, tag: 'fish',
}]

const mockedBreadcrumbs = `
  <div class="container">
    <ul class="breadcrumb" itemtype="https://schema.org/BreadcrumbList" itemscope="itemscope">
      <li itemprop="itemListElement" itemscope="itemscope" itemtype="" class="breadcrumb__item">
        <a
          itemtype="http://schema.org/Thing"
          itemprop="item"
          itemscope="itemscope"
          title="3D Models"
          id="18b3c297f15f4f0d2dd88f33d37d3b70"
          href="#"
        >
          <span itemprop="name">3D Models</span>
        </a>
        <meta itemprop="position" content="1">
      </li>
      <li itemprop="itemListElement" itemscope="itemscope" itemtype="" class="breadcrumb__item">
        <span itemtype="http://schema.org/Thing" itemprop="item" itemscope="itemscope">
          <span itemprop="name">Car 3D models</span>
        </span>
        <meta itemprop="position" content="2">
      </li>
    </ul>
  </div>
`

export { mockedSeoTags, mockedBreadcrumbs }
